import { ulid } from 'ulid';
import { v4 as uuidv4 } from 'uuid';

export const getUlidId = ulid;

export const getUuId = uuidv4;
